module.exports = __webpack_public_path__ + "img/tongyi.28e980e5.png";